import { render, staticRenderFns } from "./MallTaxi.vue?vue&type=template&id=30d8cd91&scoped=true"
import script from "./MallTaxi.vue?vue&type=script&lang=js"
export * from "./MallTaxi.vue?vue&type=script&lang=js"
import style0 from "./MallTaxi.vue?vue&type=style&index=0&id=30d8cd91&prod&lang=scss&scoped=true"
import style1 from "./MallTaxi.vue?vue&type=style&index=1&id=30d8cd91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d8cd91",
  null
  
)

export default component.exports